import { useState } from "react";
import { api } from "@/lib/api";
import { useQuery, invalidate } from "@/lib/useQuery";
import type { AccountDetail, Ticket } from "@/lib/types";
import { Button } from "@/components/ui";
import { TicketTable, TicketModal } from "@/pages/TicketsPage";

export function TicketsTab({ account, onNew }: { account: AccountDetail; onNew?: () => void }) {
  const [state, setState] = useState<"open" | "all">("open");
  const [open, setOpen] = useState<string | null>(null);
  const { data, loading, refetch } = useQuery<Ticket[]>(`tickets:acct:${account.id}:${state}`, () => api.get<Ticket[]>(`/tickets?accountId=${account.id}&state=${state}`), [account.id, state]);
  return (
    <>
      <div className="row gap-8 mb-12">
        <div className="seg"><button className={state === "open" ? "active" : ""} onClick={() => setState("open")}>Open</button><button className={state === "all" ? "active" : ""} onClick={() => setState("all")}>All</button></div>
        <Button variant="primary" className="ml-auto" onClick={onNew}>New ticket</Button>
      </div>
      <TicketTable tickets={data} loading={loading} onOpen={(t) => setOpen(t.id)} />
      {open && <TicketModal id={open} onClose={() => setOpen(null)} onChanged={() => { refetch(); invalidate("badges"); invalidate(`account:${account.id}`); invalidate(`activity:${account.id}`); }} />}
    </>
  );
}
